<ng-container *ngIf="{ isOnline: isOnline$ | async } as config">
    <div
        *ngIf="config.isOnline === false"
        @fadeSlideUp
        class="banner-container"
    >
        <span class="body-m font-medium">You're offline</span>
        <span class="body-s"
            >Some features of the application won't be available.</span
        >
    </div>
</ng-container>
